import { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { clearSession, isSessionExpired } from "../../utils/session";

export const ProtectedRoute = ({ children, permission }) => {
  const navigate = useNavigate();
  const hasToken = Boolean(localStorage.getItem("authToken"));
  const sessionExpired = hasToken && isSessionExpired();

  const permissions = JSON.parse(localStorage.getItem("permissions")) || [];

  const unauthorized = permission && !permissions.includes(permission);

  useEffect(() => {
    if (unauthorized) {
      const timer = setTimeout(() => {
        navigate(-1); 
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [unauthorized, navigate]);

  if (!hasToken || sessionExpired) {
    clearSession();
    return <Navigate to="/login" replace />;
  }

  if (unauthorized) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          flexDirection: "column",
        }}
      >
        <h2>Unauthorized Access</h2>
        <p>This page is not assigned to you.</p>
        <p>Please contact your admin to request access.</p>
        <p>Redirecting back...</p>
      </div>
    );
  }

  return children;
};